/*
 * @providesModule FriendsTournamentController
 *
 */

export const FRIENDS_TOURNAMENT_TYPE = 'FRIENDS';

const FriendsTournamentController = {};

export default FriendsTournamentController;
